import React, { useState } from "react";
import SectionHeader from "./SectionHeader";
import { useAppContext } from "../../../../context/AppContext";
import { useFormContext } from "react-hook-form";

const initialState = {
    DoorDimensions: { isOpen: true },
    OpeningDirection: { isOpen: true },
    DoorStyle: { isOpen: true },
    ExternalDoorColour: { isOpen: true },
    HandleStyle: { isOpen: true },
    GlassOptions: { isOpen: true },
    Type: { isOpen: true },
    HouseNumber: { isOpen: true },
    Cill: { isOpen: true },
    SpyHole: { isOpen: true },
    EKey: { isOpen: true },
    Escutcheon: { isOpen: true },
    FrameExtender: { isOpen: true },
    InternalDoorColour: { isOpen: true },
    InternalHandleStyle: { isOpen: true },
    Hinge: { isOpen: true },
    OxideRange: { isOpen: true },
    ApertureDimensions: { isOpen: true },
};

const SectionWrapper = ({ name, icon, Component, componentName,subtitle,oxide,input_name }) => {
    const [isOpenState, setIsOpenState] = useState(initialState);

    const toggleSection = (section) => {
        setIsOpenState((prevState) => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                isOpen: !prevState[section].isOpen,
            },
        }));
    };

    const methods = useFormContext();
    const {
        state: { view },
        setView,
    } = useAppContext();

    return (
        <div className="flex flex-col bg-white mb-4">
            <SectionHeader
                setIsOpen={toggleSection}
                name={name}
                icon={icon}
                componentName={componentName}
                isOpenState={isOpenState}
                subtitle={subtitle}
       
            />
            {Component && (
                <Component
                    isOpen={isOpenState}
                    view={view}
                    setView={setView}
                    methods={methods}
                    oxide={oxide}
                    input_name={input_name}
                    name={name}
                    componentName={componentName}
                />
            )}
        </div>
    );
};

export default SectionWrapper;
